import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`nav-header ${isScrolled ? 'nav-scrolled' : ''}`} data-testid="site-navigation">
      <div className="container">
        <div className="nav-container">
          {/* Logo */}
          <button onClick={scrollToTop} className="nav-logo" data-testid="nav-logo-button">
            <span className="logo-text">STATÌC RÎFT</span>
            <span className="logo-subtext">Full Gauge Records</span>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('about')} className="nav-link" data-testid="nav-about-button">
              About
            </button>
            <button onClick={() => scrollToSection('music')} className="nav-link" data-testid="nav-music-button">
              Music
            </button>
            <button onClick={() => scrollToSection('upcoming')} className="nav-link nav-link-special" data-testid="nav-new-album-button">
              Statìc Oäths
            </button>
            <button onClick={() => scrollToSection('merch')} className="nav-link" data-testid="nav-merch-button">
              Merch
            </button>
            <button onClick={() => scrollToSection('contact')} className="nav-link" data-testid="nav-contact-button">
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden mobile-menu-button"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-toggle-button"
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </Button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="mobile-menu">
            <button onClick={() => scrollToSection('about')} className="mobile-menu-link" data-testid="mobile-nav-about-button">
              About
            </button>
            <button onClick={() => scrollToSection('music')} className="mobile-menu-link" data-testid="mobile-nav-music-button">
              Music
            </button>
            <button onClick={() => scrollToSection('upcoming')} className="mobile-menu-link mobile-menu-link-special" data-testid="mobile-nav-new-album-button">
              Statìc Oäths
            </button>
            <button onClick={() => scrollToSection('merch')} className="mobile-menu-link" data-testid="mobile-nav-merch-button">
              Merch
            </button>
            <button onClick={() => scrollToSection('contact')} className="mobile-menu-link" data-testid="mobile-nav-contact-button">
              Contact
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;